import { _ as _defineProperty } from '../defineProperty-DmV7cVMj.js';
import fetch from 'isomorphic-fetch';
export { default as fetch } from 'isomorphic-fetch';
import { getCookie } from '../cookie/index.js';
import LRU from '../LRUCache/index.js';
import { CURRENT_LANGUAGE_COOKIE_NAME } from '../configs/constants/index.js';
import getDeviceId from '../getDeviceId/index.js';
import RequestStore from '../RequestStore/index.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var lruCache = new LRU(10);
var makeUnique = function makeUnique(url, method, data) {
  return "".concat(url, "-").concat(method, "-").concat(data);
};
var handleRequest = function handleRequest(url, method, options) {
  var useCache = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var useJSONMethod = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var canUseCache = useCache && method === 'GET';
  if (canUseCache && lruCache.has(url)) {
    return lruCache.read(url);
  }
  var hash = makeUnique(url, method, options);
  var request = RequestStore.has(hash) ? RequestStore.get(hash) : fetch(url, options);
  RequestStore.set(hash, request);
  return request.then(function (res) {
    return useJSONMethod ? res.clone().json() : res;
  }).then(function (data) {
    RequestStore.drop(hash);
    if (canUseCache && data.status === 200) {
      lruCache.set(url, data);
    }
    return data;
  });
};
var createFetch = function createFetch() {
  var instanceOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _instanceOptions$base = instanceOptions.baseUrl,
    baseUrl = _instanceOptions$base === undefined ? '' : _instanceOptions$base,
    _instanceOptions$useC = instanceOptions.useCache,
    useCache = _instanceOptions$useC === undefined ? true : _instanceOptions$useC;
  return function (url, options) {
    var _options$timeout = options.timeout,
      timeout = _options$timeout === undefined ? instanceOptions.timeout : _options$timeout,
      isFormData = options.isFormData,
      body = options.body,
      _options$method = options.method,
      method = _options$method === undefined ? 'GET' : _options$method,
      _options$withoutLangu = options.withoutLanguageHeader,
      withoutLanguageHeader = _options$withoutLangu === undefined ? false : _options$withoutLangu,
      _options$withoutDevic = options.withoutDeviceId,
      withoutDeviceId = _options$withoutDevic === undefined ? false : _options$withoutDevic,
      _options$useJSONMetho = options.useJSONMethod,
      useJSONMethod = _options$useJSONMetho === undefined ? true : _options$useJSONMetho;
    var timer;
    var requestOptions = _objectSpread(_objectSpread(_objectSpread({}, instanceOptions), options), {}, {
      headers: _objectSpread(_objectSpread({
        Accept: 'application/json'
      }, instanceOptions.headers || {}), options.headers || {}),
      method: method
    });
    if (!withoutLanguageHeader) {
      var currentLanguage = getCookie(CURRENT_LANGUAGE_COOKIE_NAME);
      requestOptions.headers['language-code'] = currentLanguage;
    }
    if (!withoutDeviceId) {
      getDeviceId() && (requestOptions.headers.deviceId = getDeviceId());
    }
    if (body) {
      requestOptions.body = isFormData ? body : JSON.stringify(body);
    }
    return new Promise(function (resolve, reject) {
      if (instanceOptions.timeout && AbortController) {
        var controller = new AbortController();
        var signal = controller.signal;
        timer = setTimeout(function () {
          reject(new Error('Timeout for Promise'));
          controller.abort();
        }, timeout);
        requestOptions.signal = signal;
      }
      return handleRequest("".concat(baseUrl).concat(url), method, _objectSpread(_objectSpread({}, instanceOptions), requestOptions), useCache, useJSONMethod).then(resolve, reject)["finally"](function () {
        return clearTimeout(timer);
      });
    });
  };
};

export { createFetch as default };
//# sourceMappingURL=index.js.map
